import style from "./style.module.css";
import video from "../../../assets/video.svg";
import search from "../../../assets/search.svg";
import reload from "../../../assets/reload.svg";
import plus from "../../../assets/plus.svg";
import pdf from "../../../assets/pdf.svg";
import { Link } from "react-router-dom";
import { useContext } from "react";
import StoreContext from "../../../context/store";
import { getExamPdf } from "../../../api/general";

const Bar = () => {
  const { setAddExamClick, setExamInputValue, examInputValue } =
    useContext(StoreContext);

  const getExamPdfMethod = async () => {
    const response = await getExamPdf();
    if (response.error) {
      console.log("Sınav pdfi gelmedi");
      console.log(response.error, "response.erro");
    } else {
      console.log("Sınav pdfi geldi");
    }
  };

  return (
    <div className={style.container}>
      <div className={style.exams}>
        <div className={style.examstext}>Sınavlar</div>
        <Link>
          <img alt="" className={style.examsvideo} src={video}></img>
        </Link>
      </div>
      <div className={style.search}>
        <button className={style.searchicon}>
          <img alt="" src={search}></img>
        </button>
        <input
          className={style.searchinput}
          placeholder="Ara"
          onChange={(e) => {
            setExamInputValue(e.target.value);
          }}
          value={examInputValue}
        ></input>
      </div>
      <button
        onClick={() => {
          window.location.reload();
        }}
      >
        <img alt="" className={style.reload} src={reload}></img>
      </button>
      <div className={style.tabs}>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
              setAddExamClick(true);
            }}
          >
            <img alt="" src={plus}></img>
          </button>
          <div className={style.tabtext}>Yeni Sınav</div>
        </div>
        <div className={style.tab}>
          <button
            className={style.tabicon}
            onClick={() => {
           //   getExamPdfMethod();
            }}
          >
            <img alt="" src={pdf}></img>
          </button>
          <div className={style.tabtext}>PDF Yazdır</div>
        </div>
      </div>
    </div>
  );
};

export default Bar;
